import { from, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpParams,
  HttpEvent,
} from '@angular/common/http';
import { StorageService } from '@shared/services';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LangInterceptorService implements HttpInterceptor {

  constructor(private storage: StorageService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.storage.getItem('lang')).pipe(
      switchMap((lang) => {
        if (request.method !== 'GET') {
          return next.handle(request);
        }
    
        let newParams = new HttpParams({ fromString: request.params.toString() });
        newParams = newParams.append('lang', lang || 'en');
    
        const requestClone = request.clone({
          params: newParams,
        });
    
        return next.handle(requestClone);
      }));
    }
}
